import { Component, Input, OnChanges, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'fi-document-template-column-settings',
    templateUrl: './document-template-column-settings.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./document-template-column-settings.component.scss'],
    standalone: false,
})
export class FiDocumentTemplateColumnSettingsComponent implements OnChanges {
    COLUMNS: { id: number; name: string }[] = [
        {
            id: 1,
            name: 'template.one_column',
        },
        {
            id: 2,
            name: 'template.two_column',
        },
    ];

    COLUMNS_CLASSES = [
        {
            id: 0,
            title: 'Two columns 50x50',
        },
        {
            id: 1,
            title: 'Two columns 30x30',
            cssClass: 'columns-30-70',
        },
        {
            id: 2,
            title: 'Two columns 70x30',
            cssClass: 'columns-70-30',
        },
    ];

    @Input() item;
    @Input() show2colOption: boolean = true;

    ngOnChanges(changes) {
        if (changes.item) {
            if (this.item.model.Settings === undefined)
                this.item.model.Settings = {
                    Columns: 1,
                };
        }

        if (!this.show2colOption && this.item.model.Settings.Columns === 2)
            setTimeout(() => (this.item.model.Settings.Columns = 1));
    }

    isOneColumn() {
        return (
            this.item.model.Settings === undefined ||
            this.item.model.Settings.Columns === undefined ||
            this.item.model.Settings.Columns === 1
        );
    }
}
